import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localize from 'dayjs/plugin/localizedFormat'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import { SHORT_DATE_FORMAT } from './constants'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localize)
dayjs.extend(isBetween)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(relativeTime)
dayjs.extend(calendar)

dayjs.tz.setDefault("America/New_York");

export function absoluteDiff(date1, date2, unit) {
  return Math.abs(dayjs(date1).diff(date2, unit))
}

export function formatDOB(date) {
  return dayjs(date).format('L')
}

export function formatDateTime(datetime) {
  return dayjs(datetime).format('LL')
}

export function standardDateTime(datetime) {
  return dayjs(datetime).format('MM/DD/YYYY HH:mm:ss zz')
}

export function standardDate(datetime) {
  return dayjs(datetime).startOf('day').format('MM/DD/YYYY')
}

export function toShortDate(date) {
  return dayjs(date).format(SHORT_DATE_FORMAT)
}

export default dayjs
